const LoyaltyModule = () => import('./LoyaltyWalletModule.vue')
const WalletsStatistics = () => import('./views/WalletsStatistics.vue')
const WalletIndex = () => import('./views/WalletIndex.vue')

export const loyaltyWalletRoute = {
  path: '/loyalty',
  component: LoyaltyModule,
  meta: {
    title: 'LoyaltyWallet',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'wallets-statistics',
      name: 'loyaltyWalletsStatistics',
      meta: {
        permission: 'loyalty_wallet.view',
      },
      component: WalletsStatistics,
    },
    {
      path: 'wallets',
      name: 'loyaltyWallets',
      meta: {
        permission: 'loyalty_wallet.view',
      },
      component: WalletIndex,
    },
  ],
}
